<template>
  <div class="checkout-form" v-if="cart.total > 0">
    <div class="form-header">
      <h5>{{ $t("checkout.payment") }}</h5>
    </div>
    <div class="form-body">
      <div id="payment_form" class="card-container">
        <div class="card-select">
          <div id="payment" class="payment-block">
            <div
              v-for="method in payment_methods"
              :key="method.method_id"
              class="payment-item"
            >
              <PayPalMethod
                v-if="method.gateway == 'paypal'"
                :method="method"
                :active="payment.gateway == 'paypal'"
              />
              <CreditCardMethod
                v-if="method.gateway == 'creditcard'"
                :method="method"
                :active="payment.gateway == 'creditcard'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.is-danger {
  color: red;
}
</style>

<script>
/* ============
 * Checkout/Payment Component
 * ============
 *
 * Gives an idea how components work.
 */
import { mapState } from "vuex";

import CreditCardMethod from "../method/CreditCard";
import PayPalMethod from "../method/PayPal";

export default {
  /**
   * The name of the component.
   */
  name: "CheckoutPayment",

  components: {
    CreditCardMethod,
    PayPalMethod,
  },

  data() {
    return {
      showValidation: false,
      // fields
      name: "",
      email: "",
      specialNote: "",
      address: {
        street: "",
        city: "",
        state: "",
        zip: "",
      },
    };
  },
  /**
   * The computed properties that the component can use.
   */
  computed: {
    ...mapState({
      cart: (state) => state.cart,
      payment_methods: (state) => state.payment.methods,
      payment: (state) => state.payment,
    }),
  },
};
</script>
